// Values are extracted from '@fluentui/react/dist/sass/variables'
export var MEDIUM_MIN_WIDTH_PX = 480;
export var LARGE_MIN_WIDTH_PX = 640;
export var EXTRA_LARGE_MIN_WIDTH_PX = 1024;
export var EXTRA_EXTRA_LARGE_MIN_WIDTH_PX = 1365;
export var EXTRA_EXTRA_EXTRA_LARGE_MIN_WIDTH_PX = 1920;
export var mediaQueryOffset = 0.00001;
export var SMALL_MAX_WIDTH_PX = MEDIUM_MIN_WIDTH_PX - mediaQueryOffset;
export var MEDIUM_MAX_WIDTH_PX = LARGE_MIN_WIDTH_PX - mediaQueryOffset;
export var LARGE_MAX_WIDTH_PX = EXTRA_LARGE_MIN_WIDTH_PX - mediaQueryOffset;
export var EXTRA_LARGE_MAX_WIDTH_PX = EXTRA_EXTRA_LARGE_MIN_WIDTH_PX - mediaQueryOffset;
export var EXTRA_EXTRA_LARGE_MAX_WIDTH_PX = EXTRA_EXTRA_EXTRA_LARGE_MIN_WIDTH_PX - mediaQueryOffset;
export var SMALL_MEDIAQUERY = "(max-width: ".concat(SMALL_MAX_WIDTH_PX, "px)");
export var MEDIUM_MEDIAQUERY = "(max-width: ".concat(MEDIUM_MAX_WIDTH_PX, "px) and (min-width: ").concat(MEDIUM_MIN_WIDTH_PX, "px)");
export var LARGE_MEDIAQUERY = "(max-width: ".concat(LARGE_MAX_WIDTH_PX, "px) and (min-width: ").concat(LARGE_MIN_WIDTH_PX, "px)");
export var EXTRA_LARGE_MEDIAQUERY = "(max-width: ".concat(EXTRA_LARGE_MAX_WIDTH_PX, "px) and (min-width: ").concat(EXTRA_LARGE_MIN_WIDTH_PX, "px)");
export var EXTRA_EXTRA_LARGE_MEDIAQUERY = "(max-width: ".concat(EXTRA_EXTRA_LARGE_MAX_WIDTH_PX, "px) and (min-width: ").concat(EXTRA_EXTRA_LARGE_MIN_WIDTH_PX, "px)");
export var EXTRA_EXTRA_EXTRA_LARGE_MEDIAQUERY = "(min-width: ".concat(EXTRA_EXTRA_EXTRA_LARGE_MIN_WIDTH_PX, "px)");
//# sourceMappingURL=ResponsiveBreakpoints.js.map